export const SEND_OTP = "SEND_OTP";
export const VERIFY_OTP = "VERIFY_OTP";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
